/**
 * File customizer.js.
 *
 * Theme Customizer enhancements for a better user experience.
 *
 * Contains handlers to make Theme Customizer preview reload changes asynchronously.
 */
"use strict";


// https://aclaes.com/responsive-background-images-with-srcset-and-sizes/
class ResponsiveBackgroundImage {

    constructor(element) {
        this.element = element;
        this.img = element.querySelector('img');
        this.src = '';

        this.img.addEventListener('load', () => {
            this.update();
        });

        if (this.img.complete) {
            this.update();
        }
    }

    update() {
        let src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
        if (this.src !== src) {
            this.src = src;
            this.element.style.backgroundImage = 'url("' + this.src + '")';

        }
    }
}


(function($) {
	$(document).ready(function() {

		let elements = document.querySelectorAll('[data-responsive-background-image]');  
		for (let i=0; i<elements.length; i++) {  
		  new ResponsiveBackgroundImage(elements[i]);
		}


							// var lastScrollTop = 0;
							// var triggerHeight = $('#masthead').height();
							// $(window).scroll(function(event){
							//    var scroll = $(this).scrollTop();
							//    if (scroll >= triggerHeight) {
							//         $("body").addClass("header-fixed");

							//         if (scroll >= triggerHeight+200) {
							// 	        if (scroll > lastScrollTop){
							// 		       // downscroll code
							// 		       setTimeout(function(){
							// 		        $("body").removeClass("header-reveal");
							// 				}, 100);
							// 		   } else {
							// 		      // upscroll code
							// 		        $("body").addClass("header-reveal");
							// 		   }
							// 		}
							// 	   lastScrollTop = scroll;
							//    } else {
							//         $("body").removeClass("header-fixed");
							//         $("body").removeClass("header-reveal");
							//         return;
							//    }
							// });

		// $("form .ginput_complex :input").each(function(index, elem) {
		// 	var eId = $(elem).attr("id");
		// 	var label = null;
		// 	if (eId && (label = $(elem).parents("form").find("label[for="+eId+"]")).length == 1) {
		// 	$(elem).attr("placeholder", $(label).html());
		// 	$(label).hide();
		// 	}
		// });

$(".slick").slick({

  // normal options...
  // infinite: false,
  // dots: true,
  //  speed: 500,
	
      infinite: true,
      speed: 1500,
      fade: true,
      slidesToShow: 1,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,

  // // the magic
  // responsive: [{

  //     breakpoint: 1024,
  //     settings: {
  //       slidesToShow: 3,
  //       infinite: true
  //     }

  //   }, {

  //     breakpoint: 600,
  //     settings: {
  //       slidesToShow: 2,
  //       dots: true
  //     }

  //   }, {

  //     breakpoint: 300,
  //     settings: "unslick" // destroys slick

  //   }]
});

		// $(window).scroll(function() {    

		//     var scroll = $(window).scrollTop();
		//     console.log (scroll);
		//     if (scroll >= 200) {
		//         $("body").addClass("header-fixed");
		//     } else {
		//         $("body").removeClass("header-fixed");
		//     }
		// });

		// // Nav Desktop Hover Classes
		// $('.menu-toggle').addClass('dropdown-toggle');
		// $('.detail-nav-toggle').attr('data-toggle', 'dropdown');
		// $('.detail-list').addClass('dropdown-menu');
		// $('.detail-list').removeClass('collapse');
		// $('.detail-list').removeClass('in');


          // // initialize Masonry
          // var $container = $('#masonryContainer');

          // $container.multipleFilterMasonry({
          //   itemSelector: '.challenge',
          //   filtersGroupSelector:'.filters'
          // });


  $(".slideshow").slick({

		  // normal options...
		  // infinite: false,
		  // dots: true,
		  //  speed: 500,
			
		      infinite: true,
		      speed: 1500,
		      // fade: true,
		      slidesToShow: 1,
		      adaptiveHeight: true,
		      // autoplay: true,
		      // autoplaySpeed: 3000,
		      // arrows: true,

		  // // the magic
		  // responsive: [{

		  //     breakpoint: 1024,
		  //     settings: {
		  //       slidesToShow: 3,
		  //       infinite: true
		  //     }

		  //   }, {

		  //     breakpoint: 600,
		  //     settings: {
		  //       slidesToShow: 2,
		  //       dots: true
		  //     }

		  //   }, {

		  //     breakpoint: 300,
		  //     settings: "unslick" // destroys slick

		  //   }]
	});
$('.slider-nav').slick({
	arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.slideshow',
  centerMode: true,
  focusOnSelect: true
});


    }); //end docready

	// // Bind to the load event of the window object
	// $(window).on("load", function () {
	// 	$('button.menu-toggle').click(function(){
	// 		$('body').toggleClass('mobile-menu-open');
	// 		$('#masthead').toggleClass('site-header-closed');
	// 	});
	// 	// $('div.close-icon').click(function(){
	// 	// 	$('body').removeClass('mobile-menu-open');
	// 	// });
	// })


})(jQuery);


